<template>
    <div class="center mb-4 divider-wrapper">
        <h1 class="title">{{ sectionTitle }}</h1>
        <div class="divider"></div>
    </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    sectionTitle: String,
  }
}
</script>

<style lang="scss">
.divider-wrapper {
    display: flex;
    align-items: center;

    .title {
        flex: 0.5;
        font-size: 20px;
        white-space: nowrap;
        color: #00bb65;
        margin-bottom: 0 !important;
        margin-right: 10px;
    }

    .divider {
        flex: 9.5;
        height: 2px;
        background-color: #00bb65;
        position: relative;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #00bb65;
            transform: translateY(-4px);
        }
    }
}
</style>